import { index } from '../api.js'
const state = {
  pages: undefined,
  home: { content: { rendered: '<p>Conteúdo da home temporário para teste.</p>' } },
  services: { 
    acf: { 
      abstract_c: '<p>Oferecemos assessoria estatística completa para pesquisas acadêmicas, projetos de desenvolvimento e análise de dados complexos. Nossa equipe de especialistas está pronta para apoiar desde o planejamento até a interpretação dos resultados.</p>',
      abstract_d: '<p>Prestamos consultoria especializada em análise estatística, modelagem de dados, machine learning e visualização de informações. Transformamos seus dados em insights estratégicos para tomada de decisão baseada em evidências.</p>'
    },
    content: { rendered: '<p>Desenvolvemos soluções estatísticas personalizadas para empresas, instituições de pesquisa e órgãos governamentais. Metodologias rigorosas e resultados confiáveis para embasar suas decisões.</p>' }
  },
  about: { 
    acf: { 
      abstract_a: '<p>Sobre a Rede de Assessoria e Consultoria em Estatística.</p>'
    },
    content: { rendered: '<p>Conteúdo sobre temporário para teste.</p>' } 
  },
  network: { 
    acf: { 
      abstract_a: '<p>Nossa rede de profissionais especializados em estatística.</p>'
    },
    content: { rendered: '<p>Conteúdo network temporário para teste.</p>' } 
  }
}

const getters = {
  pages: state => state.pages,
  home: state => state.home,
  services: state => state.services,
  about: state => state.about,
  network: state => state.network
}

const mutations = {
  SET_PAGES (state, pages) {
    state.pages = pages
    // Só sobrescrever se os dados existirem, caso contrário mantém os dados temporários
    if (pages && pages[index.home]) state.home = pages[index.home]
    if (pages && pages[index.about]) state.about = pages[index.about]
    if (pages && pages[index.services]) state.services = pages[index.services]
    if (pages && pages[index.network]) state.network = pages[index.network]
  }
}

const actions = {
  setPages ({ commit }, that) {
    // Conteudo vem do backend (substitui o WordPress). Se falhar, ficam os textos acima.
    that.$http.get(that.$api({ target: 'pages' })).then(response => {
      commit('SET_PAGES', response.data)
    }).catch(() => {})
  }
}

export default {
  state, getters, mutations, actions
}
